import Vue from "vue";
import Router from "vue-router";
import Frame from './views/Frame';


Vue.use(Router);
function _import(view) {
  return () => import('@/views/' + view);
}
const router =  new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "frame",
      component: Frame,
      children: [
        {path: '', redirect: 'home'},
        {path: 'pages/index/index', redirect: 'home'},
        {path: 'home', component: _import('home/Home'), meta: {title: '珍饰物语'}},
        {path: 'pages/category/index', component: _import('classify/Classify'), meta: {title: '分类'}},
        { path: 'community', 
          component: _import('community/tab'), 
          meta: {title: '社区'},
          children: [
            {path: '', redirect: 'circle'},
            {
              path: 'circle', component: _import('community/circle'), meta: {title: '圈子互动'},
              children: [
                {path: '', redirect: 'all'},
                {path: 'all',name: 'TalkAll', component: _import('talk/All'), meta: {title: '圈子'}},
                {path: 'follow', name: 'TalkFollow', component: _import('talk/Follow'), meta: {title: '关注'}}, 
              ]
            },
            {path: 'news', name: 'ExhibitionNews', component: _import('community/News'), meta: {title: '资讯'}},
            {path: 'school', name: 'ExhibitionSchool', component: _import('community/School'), meta: {title: '学堂'}},
          ]
        },
        {path: 'pages/flow/index', component: _import('cart/Cart'), meta: {title: '购物车'}},
        {path: 'pages/user/index', component: _import('user/User'), meta: {title: '我的'}},
      ]
    },
    {
      path: '/wxapp',
      component: _import('wxapp/tab'), 
      meta: {title: '社区'},
      children: [
        {path: '', redirect: 'circle'},
        {
          path: 'circle', component: _import('wxapp/circle'), meta: {title: '圈子互动'},
          children: [
            {path: '', redirect: 'all'},
            {path: 'all', component: _import('talk/All'), meta: {title: '圈子'}},
            {path: 'follow',  component: _import('talk/Follow'), meta: {title: '关注'}}, 
          ]
        },
        {path: 'news',  component: _import('community/News'), meta: {title: '资讯'}},
        {path: 'school',  component: _import('community/School'), meta: {title: '学堂'}},
      ]
    },
    {
      path: '/wxappUserInfo',
      component: _import('wxapp/WrapKeepAlive'), 
      children: [  
        {path: '', name: 'My', component: _import('wxapp/Info'), meta: {title: '个人中心'}},
        {path: 'social/:isFans', name: 'UserFans', component: _import('wxapp/Fans'), meta: {title: '我的社交'}},
      ]
    }, 
    // {
    //   path: '/login_wechat',
    //   component: _import('login_wechat/login_wechat'),
    // },
    {
      path: '/article/detail/:id',
      name: 'ArticleDetail',
      component: _import('community/ArticleDetail'),
      meta: {title: '展览详情'}
    },
    {path: '/publish', name: 'TalkPublish', component: _import('talk/Publish'), meta: {title: '发布'}},
    {
      path: '/publish-we-chat',
      name: 'TalkPublishWeChat',
      component: _import('talk/PublishWeChat'),
      meta: {title: '发布'}
    },
    {
      path: '/publish-article',
      name: 'TalkPublishArticle',
      component: _import('talk/PublishArticle'),
      meta: {title: '发布文章'}
    },
   {
    path: "/pages/category/list",
    name: "goodlist",
    component: _import('classify/GoodsList'), meta: {title: '商品列表'},
   },
   {
    path: "/pages/goods/index",
    name: "detail",
    component: _import('classify/Detail'), meta: {title: '商品详情'},
   },
   {
    path: "/login",
    name: "login",
    component: _import('login/login'), meta: {title: '登录'},
   },
   {
    path: "/pages/address/index",
    name: "address",
    component: _import('address/Address'), meta: {title: '地址'},
   },
   {
    path: "/pages/coupon/coupon",
    name: "coupon",
    component: _import('coupon/Coupon'), meta: {title: '领券中心'},
   },
   {
    path: "/pages/user/help",
    name: "help",
    component: _import('help/Help'), meta: {title: '帮助'},
   },
   {
    path: "/pages/user/coupon/coupon",
    name: "mycoupon",
    component: _import('coupon/MyCoupon'), meta: {title: '我的优惠券'},
   },
   {
    path: "/pages/sharing/order/index",
    name: "assemble",
    component: _import('share/Assemble'), meta: {title: '拼团'},
   },
   {
    path: "/pages/address/add",
    name: "addaddress",
    component: _import('address/AddAddress'), meta: {title: '新增地址'},
   },
   {
    path: "/pages/address/edit",
    name: "editaddress",
    component: _import('address/EditAddress'), meta: {title: '修改地址'},
   },
   {
    path: "/pages/order/index",
    name: "order",
    component: _import('order/Order'), meta: {title: '订单列表'},
   },
   {
    path: "/order/detail",
    name: "orderdetail",
    component: _import('order/OrderDetail'), meta: {title: '商品详情'},
   },
   {
    path: "/cart/sumit",
    name: "cartsub",
    component: _import('cart/CartSub'), meta: {title: '商品订单'}
   },
   {
    path: "/pages/search/index",
    name: "search",
    component: _import('search/Search'), meta: {title: '商品搜索'},
   },
   {
    path: "/pages/order/detail",
    name: "odetail",
    component: _import('order/OrderDetail'), meta: {title: '商品搜索'},
   },
   {
    path: "/pages/address/shop",
    name: "shopaddress",
    component: _import('address/ShopAddress'), meta: {title: '自提店'},
   },
   {
    path: "/support",
    name: "support",
    component: _import('support/Support'), meta: {title: '售后'},
   },
   {
    path: "/appraise",
    name: "appraise",
    component: _import('appraise/Appraise'), meta: {title: '评价'},
   },
   {
    path: "/userinfo",
    name: "userinfo",
    component: _import('user/UserInfo'), meta: {title: '个人信息'},
   },
   {
    path: "/supportdetail",
    name: "supportDetail",
    component: _import('support/SupportDetail'), meta: {title: '查看售后'},
   },
   {
    path: "/supportsub",
    name: "supportsub",
    component: _import('support/SupportSubmit'), meta: {title: '提交售后'},
   },
   {
    path: "/pages/qualityPolicy/detail",
    name: "guaranteedetail",
    component: _import('guarantee/GuaranteeDetail'), meta: {title: '质保详情'},
   },
   {
    path: "/pages/qualityPolicy/index",
    name: "guaranteelist",
    component: _import('guarantee/GuaranteeList'), meta: {title: '质保单'},
   }
  ]
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title || '珍饰物语';
  if (title) {
    document.title = title;
  }
  if(window.TDAPP) {
    let EventId = 'EVENT_ROUTER_BEFOR_EACH'
    let Label = to.path.replace(/\//g, '_')
    let MapKv = {}
    window.TDAPP.onEvent(EventId, Label, MapKv)
  }
  next();
});

export default router;

